import React from 'react';
import { FaExclamationTriangle, FaTrash } from 'react-icons/fa';
import './ConfirmModal.css';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Are you sure?', 
  message = 'This action cannot be undo.', 
  confirmText = 'Confirm', 
  type = 'danger',
  showInput = false,
  inputPlaceholder = 'Enter reason...'
}) => {
  const [reason, setReason] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  
  if (!isOpen) return null;

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      if (showInput) {
        await onConfirm(reason);
      } else {
        await onConfirm();
      }
      setReason(''); // Reset
      onClose();
    } catch (error) {
      console.error('ConfirmModal error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={onClose}>
      <div className="confirm-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className={`confirm-modal-icon ${type}`}>
          {type === 'danger' ? <FaTrash /> : <FaExclamationTriangle />}
        </div>
        
        <h2>{title}</h2>
        <p className="confirm-modal-message">{message}</p>

        {showInput && (
          <div className="confirm-modal-input-group">
            <textarea
              className="confirm-modal-textarea"
              placeholder={inputPlaceholder}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              autoFocus
            />
          </div>
        )}
        
        <div className="confirm-modal-actions">
          <button className="modal-btn modal-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button 
            className={`modal-btn modal-btn-confirm ${type} ${ (showInput && !reason.trim()) || isSubmitting ? 'disabled' : ''}`} 
            onClick={handleConfirm}
            disabled={(showInput && !reason.trim()) || isSubmitting}
          >
            {isSubmitting ? 'Processing...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
